import React from "react";
import "./styles.scss";

export default function FormField({ label, placeholder, value, onChange, type = "text", width, inputClassName, prefix, onPrefixChange, error, inputMode, multiline }) {
  const editablePrefix = typeof onPrefixChange === "function";
  return (
    <div className="form-field" style={width ? { width } : {}}>
      <label className="form-field-label">{label}</label>
      <div className={`form-field-input-wrapper${inputClassName ? ` ${inputClassName}` : ""}${error ? " form-field-input-wrapper--error" : ""}${multiline ? " form-field-input-wrapper--multiline" : ""}`}>
        {prefix !== undefined && prefix !== null && (
          <>
            {editablePrefix ? (
              <input
                className="form-field-input form-field-prefix-input"
                type="text"
                inputMode="tel"
                value={prefix}
                onChange={onPrefixChange}
                style={{ width: `${Math.max(prefix.length, 1)}ch`, flex: "0 0 auto" }}
              />
            ) : (
              <span className="form-field-prefix">{prefix}</span>
            )}
            <span className="form-field-separator">|</span>
          </>
        )}
        {multiline ? (
          <textarea
            className="form-field-input form-field-input--textarea"
            placeholder={placeholder}
            value={value}
            rows={1}
            onChange={(e) => {
              e.target.style.height = "auto";
              e.target.style.height = e.target.scrollHeight + "px";
              onChange(e);
            }}
          />
        ) : (
          <input
            className="form-field-input"
            type={type}
            inputMode={inputMode}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />
        )}
      </div>
      {error && <span className="form-field-error">{error}</span>}
    </div>
  );
}
